import React, { useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';
import Button from '../../../common/components/Button/Button';
import { useNotifications } from '../../../common/hooks/useNotifications';

import { PurchaseInvoiceSearch } from './PurchaseInvoiceSearch';

export const ProjectPurchaseInvoicesView: React.FC = () => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const nav = useNavigation();
  const { t, tk } = useTranslation('fvzLng');
  const [waiting, setWaiting] = useState<boolean>(false);

  const handleClick = (id: string, newWindow?: boolean) => {
    nav.projectPurchaseInvoiceEditor(id, newWindow);
  };

  const getSummary = useMemo(
    () => (filterText?: string, filterColumns?: string) =>
      pok.purchaseInvoices.getSumAllWithTeamsForPurchaseInvoices(
        t,
        tk,
        filterText,
        filterColumns,
      ),
    [pok.purchaseInvoices, t, tk],
  );

  const getData = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.purchaseInvoices.getAllWithTeamsByPortion(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok, t, tk],
  );

  const exportToXls = async () => {
    setWaiting(true);
    const currentDate = new Date().toISOString().split('T')[0];
    pok.reports
      .reportExcelForPurchaseWithTeams(
        `${t(tk.finance.purchaseForAllTeamsFileName)}_${currentDate}.xlsx`,
      )
      .catch(errorResponse => {
        notifications.caughtError(errorResponse);
      })
      .finally(() => {
        setWaiting(false);
      });
  };

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">
          {t(tk.finance.purchaseInvoicesToBeClarified)}
        </Card.Title>
        <PurchaseInvoiceSearch
          getData={getData}
          getCount={pok.purchaseInvoices.getAllWithTeamsCount}
          getSummary={getSummary}
          onRowClick={handleClick}
          displayTeamsProjects={true}
          displayLastNote={true}
          withFilterInColumns={true}
          withCountDays={true}
        />
        <Button
          variant="outline-secondary"
          onClick={exportToXls}
          isLoading={waiting}
        >
          {t(tk.button.export)}
        </Button>
      </Card.Body>
    </Card>
  );
};
